export default __webpack_public_path__ + "static/2-3bdacbfd463c24f1e1b2d7e561b17995.png";